<script>
import {ImgComparisonSlider} from '@img-comparison-slider/vue';
import MainButton from "@/components/Common/Buttons/MainButton.vue";

export default {
  name: 'IndexImageCompareComponent',
  components: {MainButton, ImgComparisonSlider},
  props: {
    title: {
      type: String,
    },
    description: {
      type: Array,
    }
  }
}
</script>

<template>
  <div class="compare-wrapper row g-0">
    <div class="col-md-6 col-12 d-flex align-items-center content-wrapper">
      <div>
        <div class="compare-title"> {{ title }}</div>
        <div class="compare-description"> {{ description }}</div>
        <div class=" mt-5">
          <router-link :to="{ name: 'VenousCenterView'}">
            <div class="col-md-4">
              <MainButton :button-text="$t('learn-more')" :icon="'arrow-forward'" :size="'large'"
                          :theme="'solid-blue'"/>
            </div>

          </router-link>
        </div>
      </div>


    </div>
    <div class="col-md-6 col-12">
      <ImgComparisonSlider>
        <!-- eslint-disable -->
        <img
            slot="first"
            src="/static/images/before.webp"
            style="width: 100%"
        />
        <img
            slot="second"
            src="/static/images/after.webp"
            style="width: 100%"
        />
        <!-- eslint-enable -->
      </ImgComparisonSlider>
    </div>

  </div>
</template>

<style lang="scss" scoped>
.compare-wrapper {

  .content-wrapper {
    padding: 50px 20px;
  }

  overflow: hidden;
  color: $color-brown;
  background: $color-white;
  border-radius: 30px;

  .compare-title {
    font-size: $title-h4;
    line-height: $title-h4;
  }

  .compare-description {
    margin-top: $spacing-5;
    font-size: $paragraph-1;
    line-height: $paragraph-1-lh;
  }

  .mock-image {
    max-width: 100%;
    margin-bottom: 50px;

  }
}

@media screen and (min-width: 768px) {
  .compare-wrapper {
    border-radius: 50px;

    .content-wrapper {
      padding: 80px;
    }

    .compare-title {
      font-size: $title-h2;
      line-height: 40px;
    }
  }
  .mock-image {
    margin-bottom: 0;
    width: 100%;
    height: 100%;
  }
}


</style>